/**
 * Created by vsuthar on 9/16/21
 * File: TenancyConstants
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */
export const TENANT_ADD = '/tenant_management/create_new'
export const SUBSCRIPTION_ADD = '/subscription/create_new'
export const SUBSCRIPTION_EDIT = '/subscription/create_new'
export const TENANT_DELETE = 'TENANT_DELETE'
export const TENANT_EDIT = '/tenant_management/edit'
export const ROOT_NODE_ID = '_superRoot'
export const LICENSE_STATUS_PROVISIONING = 'provisioning'
export const LICENSE_STATUS_RUNNING = 'running'
export const LICENSE_STATUS_ERROR = 'error'
export const LICENSE_STATUS_EXPIRED = 'expired'
export const LICENSE_STATUS_STOPPED = 'stopped'
export const LICENSE_STATUS_WARNING = 'warning'
export const LICENSE_STATUS_INITIALIZING = 'initializing'
export const LICENSE_STATUS_COMPLETE = 'complete'
